import React from 'react'
import {
    Button,
    Box,
    Dialog,
    DialogTitle,
    Typography,
    withStyles
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

const StyledButton = withStyles({
    root: {
        border: '1px solid black',
        color: 'black',
        backgroundImage: 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);'
    },
})(Button);

export interface StartDialogProps {
    open: boolean;
    onClose: () => void;
}

export default function StartDialog(props: StartDialogProps) {
    const { open, onClose } = props;
    const { t } = useTranslation();

    const handleClose = () => {
      onClose()
    };

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="start-classifying-dialog"
            open={open}
        >
            <Box maxWidth='400px'>
                <DialogTitle style={{ textAlign: 'center' }}>{t("propertyForm_propertyReady")}</DialogTitle>
                <Box p={4}>
                    <Typography variant="body1" align="center">
                        {t("propertyForm_propertyReady_description")}
                </Typography>
                </Box>
                <Box p={4}>
                    <StyledButton
                        // disabled={disableButton()}
                        // variant="outlined"
                        onClick={handleClose}
                        fullWidth
                    >
                        {t("propertyForm_startClassifying")}
                    </StyledButton>
                </Box>
            </Box>



        </Dialog>
    );
}
